import React, { FC } from 'react';
import moment from 'moment';
import { DatePicker, DatePickerProps } from 'antd';

interface Props {
  value?: any;
  onChange?: (value: any) => void;
  disableDateRule?: 'date <= today' | 'date > today';
  [x: string]: any;
}

const DateInput: FC<Props & DatePickerProps> = (props) => {
  const { value, onChange, disableDateRule, ...rest } = props;
  return (
    <DatePicker
      value={parseValue(value)}
      onChange={parseOnChange(onChange)}
      disabledDate={(date: any) => {
        const today = moment();
        if (disableDateRule === 'date <= today') {
          if (date.isSameOrAfter(today) && !date.isSame(today)) return true;
        }
        if (disableDateRule === 'date > today') {
          if (date.isSameOrBefore(today)) return true;
        }
        return false;
      }}
      {...rest}
    />
  );
};

const parseValue = (value?: string | moment.Moment): moment.Moment | null | undefined => {
  if (typeof value === 'string') {
    return moment(value);
  }
  return value;
};

const parseOnChange =
  (onChange: ((value: any) => void) | undefined) => (value: moment.Moment | null) => {
    onChange?.(value?.format('YYYY-MM-DD'));
  };

export default DateInput;
